
<template>
  <v-card flat style="border-radius:1px">
    <v-col cols="12" align="center" v-if="!chart_ready">
      <card-loading></card-loading>
    </v-col>

    <v-card-title primary-title v-if="chart_ready" class="pb-1">
      <v-row class="pl-4" align='baseline'>
        <v-col class="pa-0" cols="10">
          <v-row align='baseline'>
            <slot name="position"></slot>
            <div class="title mb-0">{{done_item.title}}</div>
          </v-row>
        </v-col>
        <v-col class="pa-0" cols="1">
          <v-icon color="background">mdi-star</v-icon>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-col cols="12" class="pa-0 py-2">
        {{done_item.sentence}}
        <!-- <v-subheader>{{done_item.sentence}}</v-subheader> -->
      </v-col>
      <v-col cols="12" class="py-0">
        <v-card flat style="border-radius: 1px;" v-if="chart_ready">
          <v-card-text class="pa-0">
            <v-row align='end'>
              <v-rating readonly dense half-increments :value="done_item.avg" large color="light-blue accent-4" background-color="grey lighten-1"></v-rating>
              ({{done_item.avg}})
            </v-row>
            <v-row align="center" class="mt-3">
              <span class="pt-1 light-blue--text font-weight-bold">5</span>
              <v-icon color="light-blue accent-4">mdi-star</v-icon>
              <v-col class="py-2">
                <v-progress-linear rounded height="20px" :value="done_item.result[4].value" color="light-blue accent-4">
                  <template v-slot="{ value }">
                    <strong class="white--text">{{ (value).toFixed(1) }}%</strong>
                  </template>
                </v-progress-linear>
              </v-col>
            </v-row>
            <v-row align="center">
              <span class="pt-1 light-blue--text font-weight-bold">4</span>
              <v-icon color="light-blue accent-4">mdi-star</v-icon>
              <v-col class="py-2">
                <v-row align='center'>
                  <v-col class="py-0">
                    <v-progress-linear rounded height="20px" :value="done_item.result[3].value" color="light-blue accent-4">
                      <template v-slot="{ value }">
                    <strong class="white--text">{{ (value).toFixed(1) }}%</strong>
                  </template>
                    </v-progress-linear>

                  </v-col>
                  <!-- {{done_item.result[3].value}}% -->
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center">
              <span class="pt-1 light-blue--text font-weight-bold">3</span>
              <v-icon color="light-blue accent-4">mdi-star</v-icon>
              <v-col class="py-2">
                <v-progress-linear rounded height="20px" :value="done_item.result[2].value" color="light-blue accent-4">
                  <template v-slot="{ value }">
                    <strong class="white--text">{{ (value).toFixed(1) }}%</strong>
                  </template>
                </v-progress-linear>
              </v-col>
            </v-row>
            <v-row align="center">
              <span class="pt-1 light-blue--text font-weight-bold">2</span>
              <v-icon color="light-blue accent-4">mdi-star</v-icon>
              <v-col class="py-2">
                <v-progress-linear rounded height="20px" :value="done_item.result[1].value" color="light-blue accent-4">
                  <template v-slot="{ value }">
                    <strong class="white--text">{{ (value).toFixed(1) }}%</strong>
                  </template>
                </v-progress-linear>
              </v-col>
            </v-row>
            <v-row align="center">
              <span class="pt-1 light-blue--text font-weight-bold">1</span>
              <v-icon color="light-blue accent-4">mdi-star</v-icon>
              <v-col class="py-2">
                <v-progress-linear rounded height="20px" :value="done_item.result[0].value" color="light-blue accent-4">
                  <template v-slot="{ value }">
                    <strong class="white--text">{{ (value).toFixed(1) }}%</strong>
                  </template>
                </v-progress-linear>
              </v-col>
            </v-row>

            <!-- <horizontal-bar v-if="chart_ready" :chart-data="chartData" :options="chartOptions"> </horizontal-bar> -->
            <!-- <horizontal-bar v-if="chart_ready" :chart-data="DonutData" :options="DonutOptions"> </horizontal-bar> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  props: {
    done_item: {
      type: Object,
    },
  },
  data() {
    return {
      key: null,
      chart_ready: true,

    }
  },
  methods: {
    compileAnswers(arr){
      var items = [], recur = [], prev;
      arr.sort();
      for ( var i = 0; i < arr.length; i++ ) {
        if ( arr[i] !== prev ) {
            items.push(arr[i]);
            recur.push(1);
        } else {
            recur[recur.length-1]++;
        }
        prev = arr[i];
      }
      return [items, recur];
    },
    loadResult(){
      let result = this.compileAnswers(this.done_item.answers)
         // auto-comment// console.log({result});

      let avg = this.done_item.answers.reduce((a,b)=> a+Number(b), 0) / this.done_item.answers.length
         // auto-comment// console.log({avg});

      let r = [
        {a: '1', value: result[0].indexOf('1') >= 0 ? (result[1][result[0].indexOf('1')]/this.done_item.answers.length*100) : 0},
        {a: '2', value: result[0].indexOf('2') >= 0 ? (result[1][result[0].indexOf('2')]/this.done_item.answers.length*100) : 0},
        {a: '3', value: result[0].indexOf('3') >= 0 ? (result[1][result[0].indexOf('3')]/this.done_item.answers.length*100) : 0},
        {a: '4', value: result[0].indexOf('4') >= 0 ? (result[1][result[0].indexOf('4')]/this.done_item.answers.length*100) : 0},
        {a: '5', value: result[0].indexOf('5') >= 0 ? (result[1][result[0].indexOf('5')]/this.done_item.answers.length*100) : 0},
      ]
         // auto-comment// console.log({r});
      this.done_item.result = r
      this.done_item.avg = avg.toFixed(1)
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  created () {
    this.loadResult();
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>